import { useTranslation } from 'react-i18next';

import { Button } from '@app/shared/ui/atoms/Common';
import { BannerContentContainer, WhatIsDomVideo } from '@app/shared/ui/molecules/Home';

interface WhatIsDomBannerProps {
  isVideoHidden: boolean;
  toggleVideoHidden: () => void;
}

export function WhatIsDomBanner({ isVideoHidden, toggleVideoHidden }: WhatIsDomBannerProps) {
  const { t } = useTranslation();

  if (isVideoHidden) {
    return (
      <BannerContentContainer containerClassname="mt-auto">
        <Button className="px-2" shadow="cyan" onClick={toggleVideoHidden}>
          {t('home.slider.what_is_dom.button')}
        </Button>
      </BannerContentContainer>
    );
  }

  return <WhatIsDomVideo onBtnClick={toggleVideoHidden} />;
}
